/**
 * A route param is "missing" if it's null/undefined, empty, or the literal
 * string "undefined" (which can appear when an undefined value is interpolated
 * into a URL path).
 */
export function isMissingRouteParam(value: unknown): boolean {
  return value === undefined || value === null || value === '' || value === 'undefined';
}

/** True only when every supplied route param is present. */
export function hasAllRouteParams(...values: unknown[]): boolean {
  return values.every(v => !isMissingRouteParam(v));
}

/**
 * Builds Angular router commands for the edit-integration-new route, or returns
 * null when any required param is missing so [routerLink]="null" blocks navigation.
 */
export function buildEditIntegrationNewLink(
  baseWord: unknown,
  datasourceId: unknown,
  integrationName: unknown,
  sourceId: unknown,
): unknown[] | null {
  return hasAllRouteParams(baseWord, datasourceId, integrationName, sourceId)
    ? ['/', baseWord, 'edit-integration-new', datasourceId, integrationName, sourceId]
    : null;
}
